export const collegeCornerSegmentTitles = {
    COLLEGE_CORNER_LINK: 'College Corner Link Clicked',
    OVERVIEW_TAB: 'College Corner Overview Tab Clicked',
    PLAYERS_TAB: 'College Corner College Players Tab Clicked',
    COLLEGE_TAB: 'College Corner College Teams Tab Clicked',
    JUNIOR_PROSPECT_TAB: 'College Corner Junior Prospects Tab Clicked',
};
